"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateEl = generateEl;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _PTTLayout = require("../components/PTTLayout");

var _useCombinedRefs = require("../hooks/useCombinedRefs");

var _useEvent = require("../hooks/useEvent");

var _useLayoutEffectSSRSafe = require("../hooks/useLayoutEffectSSRSafe");

var _excluded = ["children", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function generateEl(el, displayName) {
  var events = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  // Web components wrapper
  var Wrapper = /*#__PURE__*/_react["default"].forwardRef(function Wrapper(_ref, ref) {
    var _ref$children = _ref.children,
        children = _ref$children === void 0 ? null : _ref$children,
        _ref$className = _ref.className,
        className = _ref$className === void 0 ? '' : _ref$className,
        rest = _objectWithoutProperties(_ref, _excluded);

    var Tag = el; // We use forwardRef but we also need to use that ref internally: https://itnext.io/reusing-the-ref-from-forwardref-with-react-hooks-4ce9df693dd

    var combinedRef = (0, _useCombinedRefs.useCombinedRefs)(ref); // Forwards the event to corresponding `onCamelCaseEventName` prop

    var handleEvent = (0, _useEvent.useEvent)(function (event) {
      var reactEventName = toCamelCase("on-".concat(event));

      if (rest[reactEventName]) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        rest[reactEventName].apply(rest, args);
      }
    });
    (0, _useLayoutEffectSSRSafe.useLayoutEffectSSRSafe)(function () {
      var eventHandlersByName = events.reduce(function (acc, event) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, event, function () {
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          return handleEvent.apply(void 0, [event].concat(args));
        }));
      }, {}); // Add an event listener for each specified event

      events.forEach(function (event) {
        var _combinedRef$current;

        combinedRef === null || combinedRef === void 0 ? void 0 : (_combinedRef$current = combinedRef.current) === null || _combinedRef$current === void 0 ? void 0 : _combinedRef$current.addEventListener(event, eventHandlersByName[event]);
      });
      return function () {
        // Remove the event listener for each specified event
        events.forEach(function (event) {
          var _combinedRef$current2;

          combinedRef === null || combinedRef === void 0 ? void 0 : (_combinedRef$current2 = combinedRef.current) === null || _combinedRef$current2 === void 0 ? void 0 : _combinedRef$current2.removeEventListener(event, eventHandlersByName[event]);
        });
      };
    }, []);
    (0, _useLayoutEffectSSRSafe.useLayoutEffectSSRSafe)(function () {
      // Forwarding functions as props
      Object.keys(rest).forEach(function (propName) {
        // If a prop is a function and is not in the list of events, we forward it as a prop
        if (typeof rest[propName] === 'function') {
          var eventName = toKebabCase(propName.replace(/^(on)/, ''));

          if (!events.includes(eventName)) {
            combinedRef.current[propName] = rest[propName];
          }
        }
      });
    }); // Remove undefined or null attributes

    var restDefined = Object.keys(rest).reduce(function (result, key) {
      if (rest[key] !== null && rest[key] !== undefined && typeof rest[key] !== 'function' && (typeof rest[key] !== 'boolean' || rest[key])) {
        // Support both the camelCase and kebab-case version
        result[toKebabCase(key)] = rest[key];
        result[key] = rest[key];
      }

      return result;
    }, {});
    return (
      /*#__PURE__*/
      // For webcomponents, we need to use `class` instead of `className`
      _react["default"].createElement(Tag, _extends({
        ref: combinedRef,
        "class": className
      }, restDefined), children)
    );
  });

  Wrapper.displayName = displayName || el;
  return (0, _styledComponents["default"])(Wrapper).withConfig({
    displayName: "generateEl",
    componentId: "sc-j4rim6-0"
  })(["", ""], _PTTLayout.Layout);
}

function toKebabCase(str) {
  return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
}

function toCamelCase(str) {
  return str.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
}